import * as http from '@/api/config';

/* 获取机器人话术本 */
export function getAdminRobotSpeechList(data) {
    const url = 'robot/admin/v1/speech/list';
    return http.$get(url, data);
}
/* 关闭话术 */
export function closeAdminRobotSpeech(uuid) {
    const url = 'robot/admin/v1/speech/close/' + uuid;
    return http.$put(url);
}
/* 发布话术 */
export function publishAdminRobotSpeech(uuid) {
    const url = 'robot/admin/v1/speech/publish/' + uuid;
    return http.$put(url);
}

/* 移除话术 */
export function deleteAdminRobotSpeech(uuid) {
    const url = 'robot/admin/v1/speech/delete/' + uuid;
    return http.$delete(url);
}



// WEBPACK FOOTER //
// ./src/api/module/robot.js